


















import { namespace } from 'vuex-class';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { ICheckoutCartOffer, ICheckoutCartOfferEligibility } from '@/interfaces/Checkout';
import { EBankSlipInstallmentSteps } from '@/shared/enums/EBankSlipInstallmentSteps';

import KoinOptin from './Steps/KoinOptin.vue';
import KoinLoading from './Steps/KoinLoading.vue';
import KoinInstallmentSelect from './Steps/KoinInstallmentSelect.vue';
import { addScriptKoin } from '@/helpers/dom';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    KoinOptin,
    KoinLoading,
    KoinInstallmentSelect,
  }
})
export default class Koin extends Vue {
  @Prop()
  private readonly bankslip: any;

  @CheckoutModule.State('offerLoading')
  private loading!: boolean;

  @CheckoutModule.Getter('bankSlipAcceptedTermsChecked')
  private acceptedTermsChecked!: boolean;

  @CheckoutModule.Getter
  private readonly bankSlipStep!: string;

  @CheckoutModule.Getter
  private readonly isKoinActivated!: boolean;

  @CheckoutModule.Getter('selectedOffer')
  private offer: ICheckoutCartOffer;

  @CheckoutModule.Getter
  private selectedOfferEligibility: ICheckoutCartOfferEligibility;

  @CheckoutModule.Mutation
  private readonly setKoinStepsActivated!: Function;

  @CheckoutModule.Mutation
  private selectOfferPaymentBankSlipInstallment: Function;

  @CheckoutModule.Mutation
  private setBankSlipInstallmentsStep!: Function;

  private get bankSlipInstallmentSteps() {
    return EBankSlipInstallmentSteps;
  }

  private get showStepInstallments() {
    return !this.loading && this.isKoinActivated && this.bankSlipStep === this.bankSlipInstallmentSteps.installments;
  }

  private get showStepOptin() {
    return !this.loading && this.bankSlipStep === this.bankSlipInstallmentSteps.optin;
  }

  private get showStepLoading() {
    return this.loading;
  }

  private goBack() {
    this.setKoinStepsActivated(false);
    this.setBankSlipInstallmentsStep(this.bankSlipInstallmentSteps.initial);
  }

  private setPaymentBankSlipInstallment(installment: any) {
    this.selectOfferPaymentBankSlipInstallment({
      offer_id: this.offer.id,
      installment,
    });
  }

  private prepareBankSlipInstallments(payload: any) {
    this.$emit('prepareBankSlipInstallments', payload);
  }

  @Watch('loading')
  private newLoadingValue(value: boolean) {
    let eligibility = this.selectedOfferEligibility;

    if (this.acceptedTermsChecked) {
      if (value) this.setBankSlipInstallmentsStep(this.bankSlipInstallmentSteps.loading);

      if (this.acceptedTermsChecked && !value && eligibility && !eligibility.eligible && eligibility.eligible_action === 'reject' && eligibility.error_code === 1107) {
        this.setBankSlipInstallmentsStep(this.bankSlipInstallmentSteps.initial);
      } else {
        this.setBankSlipInstallmentsStep(EBankSlipInstallmentSteps.installments);
      }
    }
  }

  mounted() {
    const scriptKoinTag: any = document.getElementById('script-koin');
    if (!scriptKoinTag) addScriptKoin();
  }
}
